import Clientes         from "@/views/modulos/clientes/List.vue";
import Usuarios         from "@/views/modulos/usuarios/List.vue";
import Folios           from "@/views/catalogos/folios/List.vue";
import Perfiles         from "../views/catalogos/perfiles/List.vue";
import Permisos         from "../views/catalogos/permisos/List.vue";
import Paneles          from "../views/catalogos/paneles/List.vue";
import AsigPermisos     from "../views/catalogos/menusxPerfil/AsignarList.vue";

const VarRutasSeguridad=[
    {
        path: '/clientes',
        name: 'clientes',
        component: Clientes,
        props: true,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/usuarios',
        name: 'usuarios',
        component: Usuarios,
        props: true,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/usuariosclientes',
        name: 'usuariosclientes',
        component: Usuarios,
        props: true,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/folios',
        name: 'folios',
        component: Folios,
        props: true,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/Perfiles',
        name: 'perfiles',
        component: Perfiles,
        props: true
    },
     {
        path: '/Paneles',
        name: 'paneles',
        component: Paneles,
        props: true
    }, {
        path: '/Permisos',
        name: 'permisos',
        component: Permisos,
        props: false
    }, {
        path: '/AsignarPermiso',
        name: 'asignarPermisos',
        component: AsigPermisos,
        props: true
    },
];
export default {
    VarRutasSeguridad,
}